// extracted by mini-css-extract-plugin
export default {"player_wrapper":"VideoPlayer_player_wrapper__wmtFO","video_title":"VideoPlayer_video_title__VOcru"};